export const DEFAULT_LANGUAGE = "pt";
export const ROLE_LABELS = {
    user: "User",
    super_user: "Super User",
    team_member: "Team Member",
};
export function hasRole(user, role) {
    return user.roles.includes(role);
}
export function isSuperUser(user) {
    return hasRole(user, "super_user");
}
export const emptyInvoiceFields = () => ({
    vendor: null,
    invoiceNumber: null,
    invoiceDate: null,
    dueDate: null,
    currency: null,
    subtotal: null,
    tax: null,
    total: null,
    nif: null,
    category: null,
    notes: null,
});
